<template>
    <div :class="'facet-filter-'+this.facetId" class="result-filter facet-filter">
        <h5 class="filter-title facet-type">
            <div class="btn toggle-xs" data-toggle="collapse-next">
                {{$t("service_download.filter_sorting.facet_filter_"+this.config.facetName)}}<i
                    class="icon icon-toggle-state"></i>
            </div>
        </h5>
        <div class="scroll-content collapse" v-bar>
            <ul class="list-unstyled collapse">
                <li v-bind:key="index" v-for="(option,index) in options">
                    <facet-checkbox-item :option="option" @change="updateSelection($event)"></facet-checkbox-item>
                </li>
            </ul>
        </div>
        <button @click="resetSelection()" class="btn btn-action action-remove-filter" v-show="showRemoveAction">
            {{$t("service_download.filter_sorting.filter_remove")}}
        </button>

    </div>
</template>

<script>
    import FacetCheckboxItem from "@/components/facet/FacetCheckboxItem";

    import mixin from '../FacetMixin';

    import vSelect from 'vue-select'

    export default {
        name: "FilterFacetTypeId",
        mixins: [mixin],
        components: {FacetCheckboxItem},
        props: ['value', 'facet', 'facetId', 'selection','config'],
        data: function () {
            return {
                update: true,
                options: null
            }
        },
        computed: {
        },
        watch: {
            // value(oldval, newVal) {
            //     if (!newVal)
            //         newVal = [];
            //
            //     this.options.forEach((i) => {
            //         i.selected = newVal.indexOf(i.id) >= 0
            //     })
            // }
        },
        methods: {
            getOptionName(id) {
                if(this.config.getOptionName){
                    return this.config.getOptionName.apply(this,arguments);
                }
                return this.$t("service_download.types." + id);
            },
            filterOptions(option) {
                if(this.config.filterOptions){
                    return this.config.filterOptions.apply(this,arguments);
                }
                return true;
            }
        }
    }
</script>

<style scoped>

</style>
